<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <div header class="resend-fax-modal__tabs">
    <button
      type="button"
      class="resend-fax-modal__tab"
      [class.resend-fax-modal__tab_active]="activeTab === 'Email'"
      (click)="selectTab('Email')"
    >
      Email
    </button>

    <button
      type="button"
      class="resend-fax-modal__tab"
      [class.resend-fax-modal__tab_active]="activeTab === 'Fax'"
      (click)="selectTab('Fax')"
    >
      Fax
    </button>
  </div>

  <div class="resend" [formGroup]="form">
    <div class="resend__togglers">
      <div class="resend-email-inputs" *ngIf="activeTab === 'Email'">
        <div class="resend-input">
          <span class="resend-input__key">Email *:</span>
          <div class="resend-input-wrapper">
            <input formControlName="email" aria-required="true" type="email" class="form-input resend-input__field" />

            <div class="section__buttons-wrapper">
              <button type="button" (click)="openSelectContactModal('email')" class="btn_naked section__button sep">
                <img src="assets/img/keylock-plus.svg" alt="Select from contacts" class="section__img" />
              </button>

              <button type="button" (click)="clearField('email')" class="btn_naked section__button">
                <img src="assets/img/stop.svg" alt="Clear email" class="section__img" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ./resend__togglers -->

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="resend-form">
      <ng-container *ngIf="activeTab === 'Fax'">
        <div class="resend-input">
          <span class="resend-input__key">Fax Number *:</span>
          <div class="resend-input-wrapper">
            <input formControlName="toNumber" aria-required="true" type="text" class="form-input resend-input__field" />

            <div class="section__buttons-wrapper">
              <button
                type="button"
                (click)="openSelectContactModal('toNumber')"
                class="btn_naked section__button sep"
              >
                <img src="assets/img/keylock-plus.svg" alt="Select from contacts" class="section__img" />
              </button>

              <button type="button" (click)="clearField('toNumber')" class="btn_naked section__button">
                <img src="assets/img/stop.svg" alt="Clear fax number" class="section__img" />
              </button>
            </div>
          </div>
        </div>

        <div class="resend-input">
          <span class="resend-input__key">From Number *:</span>
          <div class="resend-input-wrapper">
            <app-select
              aria-required="true"
              [items]="clientNumberOptions"
              [activeItem]="form.get('fromNumber')?.value"
              (selectChange)="changeFromNumber($event)"
              class="resend-input__field resend__select"
            ></app-select>
          </div>
        </div>
      </ng-container>

      <div class="resend-input">
        <span class="resend-input__key">Cover page:</span>
        <div class="resend-input-wrapper">
          <app-select
            [items]="coverPageOptions"
            [activeItem]="form.get('coverPage')?.value"
            (selectChange)="changeCoverPage($event)"
            placeholder="Select cover page"
            class="resend-input__field resend__select"
          ></app-select>
        </div>
      </div>

      <div class="resend-input">
        <span class="resend-input__key">Sent From<ng-container *ngIf="activeTab === 'Fax' || generateEmailBody"> *</ng-container>:</span>
        <div class="resend-input-wrapper">
          <input formControlName="sentFrom" [attr.aria-required]="activeTab === 'Fax' || generateEmailBody" type="text" class="form-input resend-input__field" />
        </div>
      </div>

      <div class="resend-input">
        <span class="resend-input__key">Deliver To<ng-container *ngIf="activeTab === 'Fax' || generateEmailBody"> *</ng-container>:</span>
        <div class="resend-input-wrapper">
          <input formControlName="deliveryTo" [attr.aria-required]="activeTab === 'Fax' || generateEmailBody" type="text" class="form-input resend-input__field" />
        </div>
      </div>

      <div class="resend-input">
        <span class="resend-input__key">Fax Subject<ng-container *ngIf="activeTab === 'Fax' || generateEmailBody"> *</ng-container>:</span>
        <div class="resend-input-wrapper">
          <input formControlName="subject" [attr.aria-required]="activeTab === 'Fax' || generateEmailBody" type="text" class="form-input resend-input__field" />
        </div>
      </div>

      <div class="resend-input">
        <span class="resend-input__key resend-input__notes"
          >Notes<ng-container *ngIf="activeTab === 'Email' && generateEmailBody"> *</ng-container>:</span
        >
        <div class="resend-input-wrapper">
          <textarea formControlName="notes" [attr.aria-required]="activeTab === 'Email' && generateEmailBody" rows="7" class="form-input resend-input__field"></textarea>
        </div>
      </div>

      <p *ngIf="errorMessage" class="form-error resend__error">{{ errorMessage }}</p>

      <button type="submit" [disabled]="isSubmitDisabled" class="btn btn_primary resend__send-btn">{{ isSending ? "Loading..." : "Send" }}</button>
    </form>
  </div>
</app-base-modal>

<app-select-contact-modal (select)="selectContact($event)"></app-select-contact-modal>
